import { render, staticRenderFns } from "./UploadOldImg.vue?vue&type=template&id=6afbb166&scoped=true"
import script from "./UploadOldImg.vue?vue&type=script&lang=js"
export * from "./UploadOldImg.vue?vue&type=script&lang=js"
import style0 from "./UploadOldImg.vue?vue&type=style&index=0&id=6afbb166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afbb166",
  null
  
)

export default component.exports